import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ngxPermissionsGuard } from 'ngx-permissions';
import {
  BASE_PERMISSIONS,
  BASE_ROLES,
  BaseAuthGuard,
  BaseErrorComponent,
  BaseProfileGuard,
  BaseAuthorisedUserGuard,
} from 'base';
import { BaseCustomerCustomerDataGuard } from 'base-customer';
import { WrapperComponent } from './layout/_components/wrapper/wrapper.component';

const ROUTES: Routes = [
  // Public routes
  { path: '', redirectTo: 'auth', pathMatch: 'full' },
  {
    path: 'auth',
    canMatch: [BaseAuthorisedUserGuard],
    loadChildren: () => import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: '401',
    component: BaseErrorComponent,
    data: {
      title: 'systemPage.401.headText',
      is401: true,
      isErrorPage: true,
    },
  },
  {
    path: '403',
    component: BaseErrorComponent,
    data: {
      title: 'systemPage.403.headText',
      is403: true,
      isErrorPage: true,
    },
  },
  {
    path: '404',
    component: BaseErrorComponent,
    data: {
      title: 'systemPage.404.headText',
      is404: true,
      isErrorPage: true,
    },
  },

  // Protected routes
  {
    path: '',
    component: WrapperComponent,
    canMatch: [BaseAuthGuard],
    canActivate: [BaseProfileGuard, BaseCustomerCustomerDataGuard],
    children: [
      {
        path: 'dashboard',
        canMatch: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: [BASE_ROLES.CUSTOMER_ADMIN, BASE_PERMISSIONS.FEATURE_VIEW_DASHBOARD],
            redirectTo: '403',
          },
        },
        loadChildren: () => import('./modules/dashboard/dashboard.module').then((m) => m.DashboardModule),
      },
      {
        path: 'administration',
        loadChildren: () =>
          import('./modules/administration/administration.module').then((m) => m.AdministrationModule),
      },
      {
        path: 'inquiries',
        canMatch: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: [BASE_ROLES.CUSTOMER_ADMIN, BASE_PERMISSIONS.FEATURE_ADMIN_INQUIRY],
            redirectTo: '403',
          },
        },
        loadChildren: () => import('./modules/inquiry/inquiry.module').then((m) => m.InquiryModule),
      },
      {
        path: 'offers',
        loadChildren: () => import('./modules/offers/offers.module').then((m) => m.OffersModule),
      },
      {
        path: 'service-provider',
        loadChildren: () => import('./modules/provider/provider.module').then((m) => m.ProviderModule),
      },
      {
        path: 'external-employees',
        canMatch: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: [
              BASE_ROLES.CUSTOMER_ADMIN,
              BASE_PERMISSIONS.FEATURE_ADMIN_ASSIGNMENTS,
              BASE_ROLES.CUSTOMER_WORK_COUNCIL,
            ],
            redirectTo: '403',
          },
        },
        loadChildren: () =>
          import('./modules/external-employees/external-employees.module').then((m) => m.ExternalEmployeesModule),
      },
      {
        path: 'time-recordings',
        canMatch: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: [
              BASE_ROLES.CUSTOMER_ADMIN,
              BASE_PERMISSIONS.FEATURE_ADMIN_ASSIGNMENTS,
              BASE_PERMISSIONS.FEATURE_ADMIN_ASSIGNMENT_DATES,
            ],
            redirectTo: '403',
          },
        },
        loadChildren: () =>
          import('./modules/time-recordings/time-recordings.module').then((m) => m.TimeRecordingsModule),
      },
      {
        path: 'planning-board',
        loadChildren: () => import('./modules/planning-board/planning-board.module').then((m) => m.PlanningBoardModule),
      },
    ],
  },
  { path: '**', redirectTo: '404' },
];

@NgModule({
  imports: [RouterModule.forRoot(ROUTES)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
